import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

// Patch: @antv/g2plot v2.4.x sets invalid CanvasDirection values ('up'/'down')
// on the canvas 2D context. Valid values are 'ltr', 'rtl', 'inherit'.
// This silently ignores invalid values to prevent console warnings.
const validDirections = new Set(['ltr', 'rtl', 'inherit']);
const proto = CanvasRenderingContext2D.prototype;
const directionDesc = Object.getOwnPropertyDescriptor(proto, 'direction') ||
  Object.getOwnPropertyDescriptor(Object.getPrototypeOf(proto), 'direction');
if (directionDesc && directionDesc.set) {
  const originalSet = directionDesc.set;
  Object.defineProperty(proto, 'direction', {
    ...directionDesc,
    set(value: string) {
      if (validDirections.has(value)) {
        originalSet.call(this, value);
      }
    },
  });
}

// Patch: Force passive event listeners for scroll-blocking events.
// @antv/g2plot adds non-passive touchstart/touchmove/mousewheel listeners
// on canvas elements, triggering Chrome violations.
(function patchPassiveEvents() {
  const original = EventTarget.prototype.addEventListener;
  const passiveEvents = new Set(['touchstart', 'touchmove', 'mousewheel', 'wheel']);
  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ) {
    if (passiveEvents.has(type)) {
      const opts: AddEventListenerOptions =
        typeof options === 'object' ? { ...options } : { capture: !!options };
      if (opts.passive === undefined) {
        opts.passive = true;
      }
      return original.call(this, type, listener, opts);
    }
    return original.call(this, type, listener, options);
  };
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)